import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles.css";
import "./review.css";
import { App } from "./ui";

createRoot(document.getElementById("root")!).render(<StrictMode><App /></StrictMode>);
